import * as yup from 'yup';

export const StockProfitabilityForm = (t: (key: string) => string) =>
  yup.object().shape({
    venueId: yup.string().required(t('stock.profitability.required')),
    commerceIds: yup.array().of(yup.string()),
    dateFrom: yup.string().required(t('stock.profitability.required')),
    dateTo: yup.string().required(t('stock.profitability.required')),
  });
